import type {
  BrandDisputeReason,
  CreatorDisputeReason,
  DisputeReason,
  DisputeStatus,
} from '../types/marketplaceDispute';

export const BRAND_DISPUTE_REASON_LABELS: Record<BrandDisputeReason, string> = {
  cancellation_request: 'Request cancellation',
  content_quality: 'Content quality',
  missed_deadline: 'Missed deadline',
  communication_breakdown: 'Communication breakdown',
  payment_issue: 'Payment / billing issue',
  other: 'Other',
};

export const CREATOR_DISPUTE_REASON_LABELS: Record<CreatorDisputeReason, string> = {
  cancellation_request: 'Request cancellation',
  compensation_issue: 'Compensation / payment issue',
  unclear_requirements: 'Unclear or changing requirements',
  communication_breakdown: 'Communication breakdown',
  brand_unresponsive: 'Brand not responding',
  other: 'Other',
};

export const ALL_BRAND_DISPUTE_REASONS = Object.keys(BRAND_DISPUTE_REASON_LABELS) as BrandDisputeReason[];
export const ALL_CREATOR_DISPUTE_REASONS = Object.keys(CREATOR_DISPUTE_REASON_LABELS) as CreatorDisputeReason[];

export function isBrandDisputeReason(reason: DisputeReason): reason is BrandDisputeReason {
  return reason in BRAND_DISPUTE_REASON_LABELS;
}

export function isCreatorDisputeReason(reason: DisputeReason): reason is CreatorDisputeReason {
  return reason in CREATOR_DISPUTE_REASON_LABELS;
}

export function isValidDisputeReasonForReporter(
  reportedBy: 'creator' | 'brand',
  reason: DisputeReason,
): boolean {
  return reportedBy === 'brand' ? isBrandDisputeReason(reason) : isCreatorDisputeReason(reason);
}

export function getDisputeReasonLabel(
  reportedBy: 'creator' | 'brand',
  reason: DisputeReason,
): string {
  if (reportedBy === 'brand' && isBrandDisputeReason(reason)) {
    return BRAND_DISPUTE_REASON_LABELS[reason];
  }
  if (reportedBy === 'creator' && isCreatorDisputeReason(reason)) {
    return CREATOR_DISPUTE_REASON_LABELS[reason];
  }
  return reason;
}

/** Statuses where the reporter cannot open a duplicate dispute. */
export const ACTIVE_DISPUTE_STATUSES: readonly DisputeStatus[] = ['open', 'under_review'];

export function isActiveDisputeStatus(status: DisputeStatus): boolean {
  return status === 'open' || status === 'under_review';
}

export function isTerminalDisputeStatus(status: DisputeStatus): boolean {
  return !isActiveDisputeStatus(status);
}
